import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import EventBus from './utils/EventBus';
import * as serviceWorker from './serviceWorker';
import App from './App';

// sentry
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: 'https://f12d331aca2348e5b402f0cac8097d88@o1115150.ingest.sentry.io/6534429',
  integrations: [new BrowserTracing({ tracingOrigins: ['*'] })],
  // environment: process.env.NODE_ENV,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
});

window.eventBus = EventBus;

// disable service worker
serviceWorker.unregister();

const firstSevenDigitsCommit = process.env.REACT_APP_VERSION?.slice(0, 7);
console.log(`Build Commit: ${firstSevenDigitsCommit}`);

ReactDOM.render(
  <React.Fragment>
    <div id="react-version">
      Current version:
      {process.env.REACT_APP_VERSION}
    </div>
    <RecoilRoot>
      <React.Suspense fallback={<div />}>
        <App />
      </React.Suspense>
    </RecoilRoot>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
